{
  "includedProducts": {
    "seatWifi": {
      "text": {
        "WIAL": "{seatType} {seatNumber} + Koko lennon Stream-paketti",
        "WIEF": "{seatType} {seatNumber} + Koko lennon Browse-paketti"
      },
      "title": "Istuinpaikka + Wifi"
    },
    "bundle": {
      "title": "Combot"
    },
    "priorityServices": {
      "text": "{displayName}"
    }
  },
  "services": {
    "bundle": {
      "amount": {
        "seatWifi": "{amount} x Istuinpaikka + Internet-yhteys"
      },
      "summary-title": "Combot",
      "seatWifi": "Istuinpaikka + Internet-yhteys"
    },
    "priority": {
      "paid": "{amount} x Priority-palvelu",
      "state": {
        "purchased": {
          "default": "Priority-palveluja ei ole vielä vahvistettu",
          "plural": "{numberOfItems} priority-palvelua vahvistettu",
          "singular": "1 priority-palvelu vahvistettu"
        },
        "selection": {
          "default": "Priority-palveluja ei ole vielä valittu",
          "plural": "{numberOfItems} priority-palvelua odottaa ostoskorissa",
          "singular": "1 priority-palvelu odottaa ostoskorissa"
        }
      }
    }
  },
  "notifications": {
    "tripContainsTrain": {
      "link": {
        "url": "#"
      }
    }
  },
  "thirdparty": {
    "expedia": {
      "nonSupportedLanguageWidget": {
        "collectAvios": "Collect Avios",
        "title": "Book a hotel in {cityName} and collect Avios",
        "description": "View our partner's hotel offers and collect Avios booking your stay in advance.",
        "ctaButton": "View hotel offers",
        "poweredBy": "Powered by"
      }
    }
  }
}
